import { convertShamsiToUnix, isObject } from "utils";

const jsonFieldConverter = value => {
    const output = {};

    value.forEach(el => {
        if (output[el.key])
            return;

        output[el.key] = el.value;
    })

    return output;
}

const fileUploadConverter = (value, dataType) => {
    if (dataType === 6) {
        const newVal = value.map(file => file.toLowerCase());
        return newVal;
    }

    return value.join(";").toLowerCase();
}

const jsonTextConverter = value => {
    try {
        const parsedData = JSON.parse(value);
        if (isObject(parsedData))
            return parsedData;
        else
            throw Object.assign(new Error());
    } catch {
        return {};
    }
}

const timeConverter = (val, time = false) => {
    if (!val || val?.length === 0)
        return null;

    return convertShamsiToUnix(val, time);
}

const validArrayType = (value, dataType) => {
    if (dataType === 6) {
        if (Array.isArray(value))
            return value;
        else
            return value ? [parseInt(value)] : [];
    }

    return value;
}

const sendTimeConverter = (inputType, value, dataType) => {
    if (dataType === 2)
        return parseInt(value);
    else if (dataType === 3)
        return parseFloat(value);

    switch (inputType) {
        case 1:
            return value || "";
        case 2:
            return value || "";
        case 5:
            return validArrayType(value, dataType);
        case 7:
            return validArrayType(value, dataType);
        case 8:
            return validArrayType(value, dataType);
        case 9:
        case 10:
            return fileUploadConverter(value, dataType);
        case 13:
            return timeConverter(value);
        case 14:
            return timeConverter(value, true);
        case 16:
            return jsonFieldConverter(value);
        case 19:
            return jsonTextConverter(value);
        case 17:
            if (dataType === 6)
                return value !== null ? [value] : [];
            else
                return value || 0;
        case 18:
            return value?.length ? value : [];
        case 20:
            return dataType === 2 ? parseInt(value) : value;
        default:
            return value;
    }
}

export default sendTimeConverter;